import { render, staticRenderFns } from "./TicketFormV2.vue?vue&type=template&id=021bd24b&scoped=true&"
import script from "./TicketFormV2.vue?vue&type=script&lang=js&"
export * from "./TicketFormV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021bd24b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VThemeProvider})
